import React from 'react';
import { Box, LinearProgress, Typography, Paper } from '@mui/material';

const ProgressBar = ({ progress }) => {
  if (progress <= 0) return null;

  return (
    <Paper elevation={3} sx={{ p: 2, mt: 2, borderRadius: 2 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="body1" fontWeight="bold">
          Uploading Video
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {progress}%
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 10,
          borderRadius: 5,
          backgroundColor: '#e0e0e0',
          '& .MuiLinearProgress-bar': {
            borderRadius: 5,
            backgroundColor: '#4caf50', // You can customize this color
          },
        }}
      />
    </Paper>
  );
};

export default ProgressBar;
